module.exports = __webpack_public_path__ + "img/mapimage.b7620463.png";